import { KeyValueItemModel } from './key-value-item.model';

export class KeyValueModel {
    key: KeyValueItemModel;
    value: KeyValueItemModel;

    constructor(key: string, value: string) {
        this.key = new KeyValueItemModel({ name: key });
        this.value = new KeyValueItemModel({ name: value });
    }
}
